module.exports = __webpack_public_path__ + "img/lightning-effect.95ee6e99.png";